module.exports = __webpack_public_path__ + "static/img/img-fj-zlgyl.5639172.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img-fj-zlgyl.png
// module id = 8SV0
// module chunks = 222